<template>
    <div class="tracking-cases">
        <b-card no-body class="p-3 mb-3">
            <DisableCaseCard :product="product"/>
            <b-row>
                <b-col cols="12" md="4" class="border-right cursor-pointer"  @click="$refs.mortgageDetailDrawer.show(product.prod_id)">
                    <div class="mb-2">
                        <b-badge class="text-white font-weight-400 badge-id mr-1">ID</b-badge>
                        <span class="text-muted text-xs">{{ product.prod_id }} | Created in {{ product.prod_created_date | dateFormatString }}</span>
                    </div>
                    <div class="my-2">
                        <span class="badge py-1" :style="{'background': CASE_COLOR[product.prod_main_status]}">{{ product.prod_main_status }}</span>
                    </div>
                    <div>
                        <div class="d-flex align-items-start">
                            <b-col cols="12" class="text-muted ml-2">
                                <span class="font-weight-500 text-dark"><i class="fa fa-home"></i> Mortgage Loan</span>
                            </b-col>
                        </div>
                        <div class="mt-3" v-if="product.product_detail.prod_pm_project_name">
                            <p class="text-xs text-muted">Project / Unit No</p>
                            <h4>{{ product.product_detail.prod_pm_project_name }} <span v-if="product.product_detail.prod_pm_unit_no">/ {{ product.product_detail.prod_pm_unit_no }}</span></h4>
                        </div>
                        <div class="mt-3">
                            <p class="text-xs text-muted">SPA price</p>
                            <h3>RM{{ product.product_banks[0].prod_bnk_spa_amount | moneyFormatter }}</h3>
                        </div>
                        <div>
                            <p class="text-xs text-muted">Total Loan Amount</p>
                            <h3>RM{{ product.product_banks[0].prod_bnk_loan_amount | moneyFormatter }}</h3>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="8" class="tracking-status d-flex flex-column justify-content-between">
                    <div class="d-flex justify-content-between">
                        <p class="font-weight-500">Tracking Status</p>
                    </div>
                    <b-container>
                        <b-row class="d-flex align-items-center rounded mt-2 py-1" style="background: #F6F9FD;"
                            v-for="bank in product.product_banks"
                            :key="bank.prod_bnk_id"
                        >
                            <b-col cols="3" class="pl-2 d-flex align-items-center text-truncate pl-0">
                                <b-button variant="primary" class="p-1 m-2" v-if="auth_user.subscription.privileges.scpk_crm_chat_massage">
                                    <!-- <el-badge :value="20" :max="5" class="item"> -->
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 24 24" class="mx-0"><path fill="currentColor" fill-rule="evenodd" d="M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-3.586l-3.707 3.707A1 1 0 0 1 6 17v-3H5a3 3 0 0 1-3-3V5zm20 4v6c0 1-.6 3-3 3h-1v3c0 .333-.2 1-1 1-.203 0-.368-.043-.5-.113L12.613 18H9l3-3h3c1.333 0 4-.8 4-4V6c1 0 3 .6 3 3z" clip-rule="evenodd"/></svg>
                                    <!-- </el-badge> -->
                                </b-button>
                                <p v-if="bank.prod_bnk_banker_detail">{{bank.prod_bnk_banker_detail.name}}</p>
                                <p v-else>N/A</p>
                            </b-col>
                            <b-col cols="3" class="text-truncate">
                                <el-image
                                    class="rounded mr-2"
                                    :src="bank.prod_bnk_logo_url"
                                    fit="cover"
                                    style="height: 15px;"
                                ></el-image>
                            </b-col>
                            <b-col cols="2" v-if="checkAppCode('sas')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256"><path fill="currentColor" d="M24 102h26v68H32a6 6 0 0 0 0 12h192a6 6 0 0 0 0-12h-18v-68h26a6 6 0 0 0 3.14-11.11l-104-64a6 6 0 0 0-6.28 0l-104 64A6 6 0 0 0 24 102Zm38 0h36v68H62Zm84 0v68h-36v-68Zm48 68h-36v-68h36ZM128 39l82.8 51H45.2Zm118 169a6 6 0 0 1-6 6H16a6 6 0 0 1 0-12h224a6 6 0 0 1 6 6Z"/></svg>
                                LO
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <b-badge pill class="text-white font-weight-500 bg-primary">{{ bank.prod_bnk_stage_status }}</b-badge>
                            </b-col>
                            <div class="d-flex  justify-content-between w-100 px-2 my-0 py-0" v-if="bank.prod_bnk_submission_date">
                                <small>Submitted: {{ bank.prod_bnk_submission_date | dateTimeFormatString }}</small>
                                <small v-if="bank.prod_bnk_lo_sign_date"><i class="fa fa fa-signature"></i> {{ bank.prod_bnk_lo_sign_date | dateTimeFormatString }}</small>
                            </div>
                            <!-- <b-col class="pr-0 text-danger">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                                30d
                            </b-col> -->
                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row>
                            <b-col cols="12" class="px-0 pt-3 mb-2">
                                <span class="text-muted pr-2 font-weight-bold">Total Banks Apply</span>
                                <span>{{ product.product_banks.length }}</span>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
        </b-card>

        <!-- Second Example -->
        <!-- <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12" md="4" class="border-right">
                    <div class="mb-2">
                        <b-badge class="text-white font-weight-400 badge-id mr-1">ID</b-badge>
                        <span class="text-muted text-xs">1244 | Created in 27 Aug, 2022</span>
                    </div>
                    <div @click="$refs.mortgageDetailDrawer.viewCaseDetailsDrawer()" class="cursor-pointer">
                        <div class="d-flex align-items-start">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 576 512"><path fill="#73839C" d="M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"/></svg>
                            <b-row>
                                <b-col cols="12" class="text-muted ml-2">
                                    <p class="font-weight-500">Personal Loan</p>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="mt-3">
                            <p class="text-xs text-muted">Loan Amount</p>
                            <h3>RM30,000.00</h3>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="8" class="tracking-status">
                    <div class="d-flex justify-content-between">
                        <p class="font-weight-500">Tracking Status</p>
                        <div>
                            <span class="text-success text-xs">
                                <span class="font-weight-600">Invoice Sent</span>
                                at
                                <span class="font-weight-600">23 Nov 2022</span>
                            </span>
                            <el-dropdown trigger="click" class="cursor-pointer">
                                <b class="el-dropdown-link">
                                    <b-icon icon="three-dots-vertical">
                                    </b-icon>
                                </b>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 512 512"><path fill="#293854" d="m362.7 19.3-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L151 475.7c14.1-4.2 27-11.8 37.4-22.2l233.3-233.2-130-130z"/></svg>
                                        View Invoice
                                    </el-dropdown-item>
                                    <el-dropdown-item class="text-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 448 512"><path fill="currentColor" d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/></svg>
                                        Delete
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <b-container>
                        <b-row class="d-flex align-items-center rounded pt-2" style="background: #F6F9FD;">
                            <b-col cols="3" class="d-flex align-items-center text-truncate pl-0">
                                <b-button variant="primary" class="p-1 m-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 24 24" class="mx-0"><path fill="currentColor" fill-rule="evenodd" d="M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-3.586l-3.707 3.707A1 1 0 0 1 6 17v-3H5a3 3 0 0 1-3-3V5zm20 4v6c0 1-.6 3-3 3h-1v3c0 .333-.2 1-1 1-.203 0-.368-.043-.5-.113L12.613 18H9l3-3h3c1.333 0 4-.8 4-4V6c1 0 3 .6 3 3z" clip-rule="evenodd"/></svg>
                                </b-button>
                                <p>Ivy</p>
                            </b-col>
                            <b-col cols="3" class="text-truncate">CIMB</b-col>
                            <b-col>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10m5 6 6-6M8 8l6-6M9 7l8 8m4-4-8-8"/></svg>
                                SPA
                            </b-col>
                            <b-col>
                                <b-badge pill class="text-white font-weight-500" style="background: #0BC196;">DONE</b-badge>
                            </b-col>
                            <b-col class="pr-0 text-danger">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                                30d
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" class="px-0 pt-2">
                                <span class="text-muted pr-2">Total Banks Apply</span>
                                <span>1</span>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
        </b-card> -->

        <!-- Drawer for Cases Details -->
        <MortgageCaseDetailsDrawer ref="mortgageDetailDrawer" :product="product"></MortgageCaseDetailsDrawer>
    </div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Image } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
} from '@/assets/js/httpImports.js'
import MortgageCaseDetailsDrawer from './MortgageCaseDetailsDrawer.vue'
import DisableCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/DisableCaseCard'
import {CASE_COLOR} from '@/assets/js/colors.js'
import { useAuthStore } from '@/stores/authStore'

export default {
    props: ['product'],
    components: {
        DisableCaseCard,
        MortgageCaseDetailsDrawer,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Image.name]: Image,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data(){
        return{
            CASE_COLOR:CASE_COLOR
        }
    },
    computed:{
        ...mapState(useAuthStore,['auth_user']),
        selectedBank(){
            let bank = null
            bank = this.product.product_banks.find((item) => item.prod_bnk_spa_status !== null || item.prod_bnk_la_status !== null)
            return bank
        }
    },
    methods: {
        ...mapActions(useProductStore, ['removeProduct']),
        getClockIconColor(created_at) {
            const date = new Date(created_at);
            const currentDate = new Date();
            const differenceInDays = Math.floor((currentDate - date) / (1000 * 60 * 60 * 24));
            
            if (differenceInDays > 7) {
                return 'text-danger'; // Change to red color class
            } else if (differenceInDays > 3) {
                return 'text-warning'; // Change to yellow color class
            } else {
                return 'text-success'; // Change to green color class
            }
        },
        async removeProductHandler(){
            try{
                await this.removeProduct(this.product)
                this.notifySuccess('<b>Case</b> - Successfully Removed.')
            }catch(e){
                this.errorFunction(null, e)
            }
        }
    }
}
</script>